
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.818 1.977a4.241 4.241 0 00-.93.1 4.943 4.943 0 00-8.027 0 4.241 4.241 0 00-.93-.1 4.943 4.943 0 00-.988 9.788v6.03c0 .546.443.99.989.99h9.886a.989.989 0 00.989-.99v-6.03a4.943 4.943 0 00-.989-9.788zm1.977 17.796H2.955a.989.989 0 100 1.977h13.84a.989.989 0 000-1.977z"}})])
          )
        }
      }
    